<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false" @close="resetForm">
    <template #title>
      <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
    </template>

    <el-form label-width="auto" ref="form" :rules="rules" :model="formData">
      <el-form-item :label="$t('规格名称')" prop="name">
        <el-input :placeholder="$t('规格名称')" v-model="formData.name" />
      </el-form-item>

      <el-form-item :label="$t('协议代码')" prop="protocolCode">
        <el-input :placeholder="$t('协议代码')" v-model="formData.protocolCode" />
      </el-form-item>

      <el-form-item :label="$t('展示内容')">
        <el-input :placeholder="$t('展示内容')" v-model="formData.content" />
      </el-form-item>

      <h5 style="font-size: 14px" class="mb16">{{$t('展示规格参数')}}</h5>

      <el-form-item :label="$t('分度值')" prop="scale">
        <el-input :placeholder="$t('分度值')" v-model="formData.scale" />
      </el-form-item>
      <el-form-item :label="$t('起称')" prop="heightage">
        <el-input :placeholder="$t('起称')" v-model="formData.heightage" />
      </el-form-item>

      <el-form-item :label="$t('误差')" prop="diff">
        <el-input :placeholder="$t('误差')" v-model="formData.diff" />
      </el-form-item>

      <el-form-item :label="$t('备注')">
        <el-input :placeholder="$t('备注')" v-model="formData.remark" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {resetEmpty} from "@/utils/common";

export default {
  name: "WeightSkuForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        name: "",
        content: "",
        protocolCode: '',
        remark: "",
        scale: "",
        heightage: "",
        diff: ""
      },
      rules: {
        name: {required: true, message: this.$t('请输入规格名称'), trigger: 'blur'},
        protocolCode:  {required: true, message: this.$t('请输入协议代码'), trigger: 'blur'},
        scale: {required: true, message: this.$t('请输入分度值'), trigger: 'blur'},
        heightage: {required: true, message: this.$t('请输入起称'), trigger: 'blur'},
        diff: {required: true, message: this.$t('请输入误差'), trigger: 'blur'},
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        this.$emit("confirm", this.formData);
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    },
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      },
      deep: true,
    },
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
